import React, { useState } from "react";
import { plannerStore } from "../../App";

const PlannerDisplayer = () => {
  const [plannerColor, setPlannerColor] = useState("#fef3c7");
  const [bindingColor, setBindingColor] = useState("#4b5563");
  const updateBindColor = plannerStore((state) => state.updateColor);
  const updatePlannerColor = plannerStore((state) => state.updatePlannerColor);
  const spiralRings = Array.from({ length: 14 });

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center justify-center relative">
        <div className="relative h-56 w-8 flex flex-col justify-evenly items-center">
          {spiralRings.map((_, i) => (
            <div key={i} className="relative flex flex-col items-center">
              <div
                className="w-1 h-5 rounded-full absolute left-0 top-0 opacity-60"
                style={{ backgroundColor: bindingColor }}
              ></div>
              <div
                className="w-1 h-5 rounded-full absolute right-0 top-0 shadow-md"
                style={{ backgroundColor: bindingColor }}
              ></div>
              <div
                className="w-6 h-[2px] absolute top-2 left-0"
                style={{
                  backgroundColor: bindingColor,
                  opacity: 0.9,
                }}
              ></div>
            </div>
          ))}
        </div>
        <div
          className="h-56 w-64 rounded-r-lg border relative transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl"
          style={{
            background: `linear-gradient(145deg, ${plannerColor}, ${plannerColor}cc)`,
            boxShadow:
              "0 4px 6px rgba(0,0,0,0.2), inset 0 2px 4px rgba(255,255,255,0.2)",
          }}
        >
          <div className="absolute top-0 left-0 right-0 h-2 bg-white/20 rounded-t-lg"></div>
          <div className="absolute right-0 top-0 bottom-0 w-[3px] bg-white/30 rounded-r-lg"></div>
        </div>
      </div>

      <div className="flex gap-20">
        <div className="flex flex-col items-center">
          <label className="text-sm font-medium">Planner Color</label>
          <input
            type="color"
            value={plannerColor}
            onChange={(e) => {
              setPlannerColor(e.target.value);
              updatePlannerColor(e.target.value);
            }}
            className="w-10 h-10 rounded cursor-pointer border"
          />
        </div>

        <div className="flex flex-col items-center">
          <label className="text-sm font-medium">Spiral Color</label>
          <input
            type="color"
            value={bindingColor}
            onChange={(e) => {
              setBindingColor(e.target.value);
              updateBindColor(e.target.value);
            }}
            className="w-10 h-10 rounded cursor-pointer border"
          />
        </div>
      </div>
    </div>
  );
};

export default PlannerDisplayer;
